import PaymentOrderRepository from "../repository/payment-order-repository";

class PaymentOrderService
{
    #paymentOrderRepository;

    constructor() {
        this.#paymentOrderRepository = new PaymentOrderRepository();
    }

    async create(paymentOrder) {
        try {
            return await this.#paymentOrderRepository.create(paymentOrder);
        } catch (error) {
            console.error(error);
        }
    }

    async edit(paymentOrder) {
        try {
            return await this.#paymentOrderRepository.edit(paymentOrder);
        } catch (error) {
            console.error(error);
        }
    }

    async remove(paymentOrder) {
        try {
            return await this.#paymentOrderRepository.remove({id: paymentOrder.id});
        } catch (error) {
            console.error(error);
        }
    }

    async findOne(id) {
        try {
            return await this.#paymentOrderRepository.getOneById(id);
        } catch (error) {
            console.error(error);
        }
    }

    async details(id) {
        try {
            return await this.#paymentOrderRepository.getDetails(id);
        } catch (error) {
            console.error(error);
        }
    }

    async gridview(query) {
        try {
            return await this.#paymentOrderRepository.gridview(query);
        } catch (error) {
            console.error(error);
        }
    }

    async pay(data) {
        try {
            return await this.#paymentOrderRepository.payment(data);
        } catch (error) {
            console.error(error);
        }
    }

    async transfer(data) {
        try {
            return await this.#paymentOrderRepository.transfer(data);
        } catch (error) {
            console.error(error);
        }
    }
}

export default PaymentOrderService;